module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane-stat-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/monitoring')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.monField) ? _c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.monField,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.monFieldChanged
    },
    model: {
      value: (_vm.monValue),
      callback: function($$v) {
        _vm.monValue = $$v
      },
      expression: "monValue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_block_cpu')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['mon']['cpu']) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['mon']['cpu'],
      "options": _vm.lineChartOptionsCpu
    }
  }) : (_vm.cacheData['mon']['cpu'] === false) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  }) : (_vm.cacheData['mon']['cpu'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_block_disk')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['mon']['disk']) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['mon']['disk'],
      "options": _vm.lineChartOptionsDisk
    }
  }) : (_vm.cacheData['mon']['disk'] === false) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  }) : (_vm.cacheData['mon']['disk'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_block_vnet')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['mon']['traf']) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['mon']['traf'],
      "options": _vm.lineChartOptionsTraf
    }
  }) : (_vm.cacheData['mon']['traf'] === false) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  }) : (_vm.cacheData['mon']['traf'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.localIpInfo && typeof _vm.localIpInfo === 'object' && _vm.localIpInfo.ip) ? _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_block_lnet')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['mon']['trafLocal']) ? _c('chartLine', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['mon']['trafLocal'],
      "options": _vm.lineChartOptionsTrafLocal
    }
  }) : (_vm.cacheData['mon']['trafLocal'] === false) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  }) : (_vm.cacheData['mon']['trafLocal'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "0",
      "margin-top": "60px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_monthly_bandwidth')))]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [(_vm.trafField) ? _c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.trafField,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.trafFieldChanged
    },
    model: {
      value: (_vm.trafValue),
      callback: function($$v) {
        _vm.trafValue = $$v
      },
      expression: "trafValue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-table"
  }, [_c('div', {
    staticClass: "w5-view-vds-stat-traf-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/usage')) + ":")]), _vm._v(" "), (_vm.cacheData['traf']['usage']) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(_vm._s(_vm.cacheData['traf']['usage']))]) : (_vm.cacheData['traf']['usage'] === false) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  }) : (_vm.cacheData['traf']['usage'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('main/no_data')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-table"
  }, [_c('div', {
    staticClass: "w5-view-vds-stat-traf-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_vnet_rx')) + ":")]), _vm._v(" "), (_vm.cacheData['traf']['rx']) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(_vm._s(_vm.cacheData['traf']['rx']))]) : (_vm.cacheData['traf']['rx'] === false) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  }) : (_vm.cacheData['traf']['rx'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('main/no_data')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-traf-table"
  }, [_c('div', {
    staticClass: "w5-view-vds-stat-traf-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/stat_vnet_tx')) + ":")]), _vm._v(" "), (_vm.cacheData['traf']['tx']) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(_vm._s(_vm.cacheData['traf']['tx']))]) : (_vm.cacheData['traf']['tx'] === false) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  }) : (_vm.cacheData['traf']['tx'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('main/no_data')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-view-vds-stat-graph-wrapper",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "w5-view-vds-stat-traf-graph"
  }, [(_vm.cacheData['traf']['data']) ? _c('chartBar', {
    staticClass: "w5-chart-graph",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "data": _vm.cacheData['traf']['data'],
      "options": _vm.barChartOptions
    }
  }) : (_vm.cacheData['traf']['data'] === false) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  }) : (_vm.cacheData['traf']['data'] === null) ? _c('div', {
    staticClass: "w5-view-vds-stat-traf-table-value"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")('service/stat_empty')))]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6c200f2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vds/stat.vue
// module id = 645
// module chunks = 0